<template>
  <div v-if="transparency" class="mt-3">
    <div
      v-if="
        transparency.biodiversity ||
        transparency.soil ||
        transparency.animals ||
        transparency.climate ||
        transparency.cycles ||
        transparency.diversification ||
        transparency.type ||
        transparency.team
      "
      class="mt-3"
    >
      <CRow class="justify-content-end align-items-start flex-column mx-0">
        <div class="mt-2 mb-0 ui-type-heading w-100">
          {{ $t("models.role.userSettings.transparency.eco.title") }}:
        </div>
      </CRow>

      <div
        class="justify-content-start align-items-start flex-column mt-1"
        v-if="transparency.biodiversity"
      >
        <div class="ui-card-product__title mb-1">
          {{ $t("models.role.userSettings.transparency.eco.label") }}:
        </div>
        <div>
          {{ transparency.biodiversity }}
        </div>
      </div>

      <div
        class="justify-content-start align-items-start flex-column mt-3"
        v-if="transparency.soil"
      >
        <div class="ui-card-product__title mb-1">
          {{ $t("models.role.userSettings.transparency.eco.soil.label") }}:
        </div>
        {{ transparency.soil }}
      </div>

      <div
        class="justify-content-start align-items-start flex-column mt-3"
        v-if="transparency.climate"
      >
        <div class="ui-card-product__title mb-1">
          {{ $t("models.role.userSettings.transparency.eco.climate.label") }}:
        </div>
        {{ transparency.climate }}
      </div>

      <div
        class="justify-content-start align-items-start flex-column mt-3"
        v-if="transparency.animals"
      >
        <div class="ui-card-product__title mb-1">
          {{ $t("models.role.userSettings.transparency.eco.animals.label") }}:
        </div>
        {{ transparency.animals }}
      </div>

      <div
        class="justify-content-start align-items-start flex-column mt-3"
        v-if="transparency.cycles"
      >
        <div class="ui-card-product__title mb-1">
          {{ $t("models.role.userSettings.transparency.eco.cycles.label") }}:
        </div>
        {{ transparency.cycles }}
      </div>

      <CRow
        class="justify-content-end align-items-start flex-column mx-0 px-0 mt-3"
      >
        <div class="mt-1 mb-0 ui-type-heading w-100">
          {{ $t("models.role.userSettings.transparency.social.title") }}:
        </div>
      </CRow>

      <div
        class="justify-content-start align-items-start flex-column mt-1"
        v-if="transparency.diversification"
      >
        <div class="ui-card-product__title mb-1">
          {{
            $t(
              "models.role.userSettings.transparency.social.diversification.label"
            )
          }}:
        </div>
        {{ transparency.diversification }}
      </div>

      <div
        class="justify-content-start align-items-start flex-column mt-3"
        v-if="transparency.type"
      >
        <div class="ui-card-product__title mb-1">
          {{ $t("models.role.userSettings.transparency.social.type.label") }}:
        </div>
        {{ transparency.type }}
      </div>

      <div
        class="justify-content-start align-items-start flex-column mt-3"
        v-if="transparency.team"
      >
        <div class="ui-card-product__title mb-1">
          {{ $t("models.role.userSettings.transparency.social.team.label") }}:
        </div>
        {{ transparency.team }}
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "MarketProducerProfileTransparency",

  props: {
    transparency: {
      type: Object,
      default: null,
    },
  },
};
</script>
